import { render, staticRenderFns } from "./CheckBoxQuiz.vue?vue&type=template&id=d693e232"
import script from "./CheckBoxQuiz.vue?vue&type=script&lang=js"
export * from "./CheckBoxQuiz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports